<div class="lightbox">
		<div class="titlebar">
			<div class="title">{{title}}</div>
			<span (click)="close()"><i class="fa fa-times"></i></span>
		</div>
		<div class="content">
			{{content}}
		</div>
	</div>